module.exports = __webpack_public_path__ + "static/media/lb.ac8aeffb.svg";